export const DELETE_NOTIFICATION = 'space/publisher/notification/DELETE'
export const DELETE_NOTIFICATION_SUCCESS = `${DELETE_NOTIFICATION}_SUCCESS`

export const FETCH_NOTIFICATION = 'space/publisher/notification/FETCH'
export const FETCH_NOTIFICATION_SUCCESS = `${FETCH_NOTIFICATION}_SUCCESS`

export const FETCH_NOTIFICATIONS_PAGINATED = 'space/publisher/notifications/FETCH'
export const FETCH_NOTIFICATIONS_PAGINATED_SUCCESS = `${FETCH_NOTIFICATIONS_PAGINATED}_SUCCESS`

export const RECALL_NOTIFICATION = 'space/publisher/notification/RECALL'
export const RECALL_NOTIFICATION_SUCCESS = `${RECALL_NOTIFICATION}_SUCCESS`
